module.exports = __webpack_public_path__ + "media/application/images/process_steps/mobile_bookstack_04-9e915d833dbc48c3c27d01a0bcde0099.png";